<div class="faspinner" *ngIf="loading">
    <dx-load-indicator width="24px" height="24px" [visible]="true"></dx-load-indicator>
</div>
<div *ngIf="!loading">
    <!-- <app-back-page (backAction)="backToMainPage()"></app-back-page> -->
    <div id="form-container">
        <form (submit)="onFormSubmit($event)">
            <dx-form  labelMode="floating" labelLocation="top" [formData]="attachmentForm" [showColonAfterLabel]="true" [showValidationSummary]="true"
                style="padding: 1rem 2rem;margin: 2rem 0rem;" [rtlEnabled]="currentLang=='ar'?true:false"
                validationGroup="true">
                <dxo-col-count-by-screen [xs]="1" [sm]="1" [md]="4" [lg]="4"></dxo-col-count-by-screen>
                <dxi-item itemType="group" caption="{{'hr.addEmployeeAttachment'|translate}}" [colCount]="2" [colSpan]="4">
                    <dxi-item dataField="notes" [colSpan]="6">
                        <dxo-label text="{{'hr.notes'|translate}}"></dxo-label>
                    </dxi-item>
    
                    <dxi-item dataField="employeeId" editorType="dxLookup" [colSpan]="6"
                        [editorOptions]="{dataSource: employeeMenu, displayExpr:'nameAr' ,valueExpr :'id' ,searchEnabled: true, showClearButton: true}">
                        <dxo-label text="{{'hr.employeeId'|translate}}"></dxo-label>
                    </dxi-item>
                    <dxi-item dataField="employeeAttachmentTypeId" editorType="dxLookup" [colSpan]="6"
                        [editorOptions]="{dataSource: AttacmentMenu, displayExpr:currentLang=='ar'?'nameAr':'nameEn' ,valueExpr :'id' ,searchEnabled: true, showClearButton: true}">
                        <dxo-label text="{{'hr.EmployeeAttachmentTypes'|translate}}"></dxo-label>
                    </dxi-item>
                    <dxi-item dataField="imagePath" [template]="'pictureTemplate'" [colSpan]="6">
                        <dxo-label text="{{'accounting.imagePath'|translate}}"></dxo-label>
                    </dxi-item>
                </dxi-item>
                    <dxi-item itemType="button" [buttonOptions]="buttonOptions">
                    </dxi-item>
                    <!-- <div *dxTemplate="let data of 'pictureTemplate'">
                        <input type="file" class="file-input" (change)="upload($event)" #fileUpload>
                        <div class="file-upload">
                         <ng-container *ngIf="uploadimage">{{fileName || noimag}}</ng-container>
                         <ng-container *ngIf="!uploadimage"><img [src]="attachmentForm.imagePath" style="max-width: 12rem;"/></ng-container>  
                        <i class="fa-solid fa-upload" (click)="fileUpload.click()"></i>
                        </div>
                    </div> -->
                    <div *dxTemplate="let data of 'pictureTemplate'">
                        <input type="file" class="file-input" (change)="upload($event)" #fileUpload>
                        <div class="file-upload" style="max-width: 50rem;">
                          <ng-container *ngIf="uploadimage; else showImage">
                            <img  (click)="openImage(attachmentForm.fileUrl)" *ngIf="attachmentForm.fileUrl" [src]="attachmentForm.fileUrl" alt="Preview Image" style="max-width: 50rem;" />
                          </ng-container>
                          <ng-template #showImage>
                            <img  (click)="openImage(attachmentForm.imagePath)" *ngIf="attachmentForm.imagePath" [src]="attachmentForm.imagePath" style="max-width: 50rem;" />
                          </ng-template>
                          <i class="fa-solid fa-upload" (click)="fileUpload.click()"></i>
                        </div>
                      </div>
                      
                      
            </dx-form>
        </form>
    </div>
</div>
